export default __webpack_public_path__ + "7683b570f32e3b4a8027d236fdd3eba5.png";